import script from "./listStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./listStudents.vue?vue&type=script&setup=true&lang=js"

import "./listStudents.vue?vue&type=style&index=0&id=290d69bf&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-290d69bf"]])

export default __exports__